import { useEffect, useState } from 'react';

const navLinks = [
  { href: '#home', label: '首页' },
  { href: '#featured', label: '热门推荐' },
  { href: '#campus', label: '校园' },
  { href: '#cohab', label: '同居' },
  { href: '#ambi', label: '暧昧' },
  { href: '#rev', label: '逆后宫' },
  { href: '#ranking', label: '排行榜' },
  { href: '#guide', label: '阅读指南' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/90 shadow-sm backdrop-blur-md' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#home" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-heart-3-fill text-lg" />
          </span>
          <span
            className={`font-label text-xl ${
              scrolled ? 'text-foreground-950' : 'text-foreground-50'
            }`}
          >
            羞羞动漫漫画
          </span>
        </a>

        <ul className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className={`whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                  scrolled
                    ? 'text-foreground-700 hover:bg-background-200 hover:text-foreground-950'
                    : 'text-foreground-100 hover:bg-background-50/10 hover:text-foreground-50'
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="#faq"
            className={`whitespace-nowrap text-sm font-semibold transition-colors ${
              scrolled ? 'text-foreground-800 hover:text-foreground-950' : 'text-foreground-100'
            }`}
          >
            常见问题
          </a>
          <a
            href="#about"
            className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            关于我们
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-md lg:hidden ${
            scrolled ? 'text-foreground-950' : 'text-foreground-50'
          }`}
        >
          <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 shadow-md lg:hidden">
          <ul className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="block whitespace-nowrap rounded-md bg-background-100 px-4 py-2.5 text-sm font-medium text-foreground-800"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <div className="mt-3 flex flex-col gap-2">
            <a
              href="#faq"
              onClick={() => setOpen(false)}
              className="block whitespace-nowrap rounded-md bg-background-100 px-4 py-2.5 text-center text-sm font-medium text-foreground-800"
            >
              常见问题
            </a>
            <a
              href="#about"
              onClick={() => setOpen(false)}
              className="block whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-center text-sm font-semibold text-background-50"
            >
              关于我们
            </a>
          </div>
        </div>
      )}
    </header>
  );
}